import React, { useState } from 'react';

const scholars = [
  "Hussain Aamir", "Muhammad Abdullah", "Abeeha", "Muhammad Abubakr",
  "Aldiyar Adilbek", "Eman Fatima Afzal", "Sehwal Afzal", "Agna",
  "Areeb Ahmad", "Muhammad Ahmad", "Umar Ahmad", "Sariya Ahmad",
  "Ain Sara", "Amirlangali Aitaza", "Abhinav Ajinkya", "Khubaib Ali",
  "Imtiaz Ali", "Syed Muhammad Yahya Ali", "Aliyan Ali", "Aliyan",
  "Fazil Hussain Alvi", "Faysal Alwir", "Amanullah", "Aibek Kyzy Amina",
  "Anas Bin Amir", "Bilal Amjad", "Hajra Ammar", "Kelvin Godwin Anaman",
  "Keshav Anand", "Praneeth Annapureddy", "Abhinav Anne", "Ayesha Anwar",
  "Nayla Alvaleta Aqmier", "Hadia Arfan", "Serik Arman", "Armeen",
  "Adhiban Arulselvan", "Muhammad Taha Asghar", "Zonain Asghar", "Muhammad Usman Asif",
  "Abdullah Asif", "Muhammad Ashmaan Aslam", "Mustafa Tomiris Asylkhankyzy", "Muhammad Atif",
  "Enjy Qaoud Ayoub", "Amina Binat Azeem", "Gloria Badibanga", "Benjamin Bartyzel",
  "Minal Bashir", "Kian Bassiri", "Samanvita Batalvi", "Dhruvin Bhandari",
  "Namya Bhatnagar", "Aharshi Bhattacharjee", "Serina Bligh", "Syed Muhammad Jamal Bukhari",
  "Robert Miguel Castigador", "Lian Cheng", "Kyle Cheng", "Satvik Reddy Chenna",
  "Saharsh Cherlapally", "Ayan Chokshi", "Ngo Bao Chau", "Souren Datta",
  "Kanushi Desai", "Ishani Desai", "Manraj Singh Dhaliwal", "Radhe Dhoundiyal",
  "Kate Ding", "Dias Dosanbekov", "Aarav Doshi", "Shambhvi DUa",
  "Rahma Ashraf Elbaaz", "Kashaf Eman", "Nouman Fahad", "Maheen Faisal",
  "Hasna Faraz", "Noor Fatima", "Fatima", "Anfal Fatima",
  "Hamza Fayyaz", "M. Umair Ghaffar", "Izza Imsal Gillani", "Dev Goyal",
  "Tanvi Gupta", "Alexis Andre Ospino Gutierrez", "Muhammad Abdullah Hafeez", "Hasnain Haider",
  "Hussam Haider", "Mikayla Lareign Harder", "Talbeha Harmain", "Yara Hasan",
  "Ali Hasnain", "Sophie Hough", "Muhammad Moman Hussain", "Muddasir Hussain",
  "Mohsin Hussain", "Syed Ali Hussain", "Muhammad Ali Hussain", "Muhammad Huzaifa",
  "Ibraheem", "Tooba Idrees", "Ifrah", "Zain Iftikhar",
  "Noor ul Imaan", "Maryam Imran", "Saad Imran", "Jannat Imran",
  "Tahreem Imtiaz", "Maliha Islam", "Yuvansh Jain", "Muhammad Ayan Janjua",
  "Uswa Javaid", "Maryam Javed", "Hadia Javed", "Aarib Kaleem",
  "Arnav Pancholy Kalla", "Adveka Kamalbabu", "Sarayu Kamath", "Zain Kamran",
  "Fizza Kamran", "Thavanes Kanakaraj", "Aadya Kanchan", "Olivia Kang",
  "Niveditha Kannan", "Johum Kanwal", "Devansh Karavati", "Mahad Kashif",
  "Maheen Kashif", "Presha Kashyap", "Gurman Kaur", "Maraljin Kennedy",
  "Rahul Khadkathoki", "Evelina Khamidullina", "Ahmed Halim Khan", "Muhammad Azan Khan",
  "Md Ali Khan", "Mohib Ahmad Khan", "Abdul Rehman Khan", "Aria Khan",
  "Rudransh Kohli", "Saikrith Koneru", "Ajitesh Kowkuntla", "Aditya Kumar",
  "Ananya Kumbhare", "Sakethram Kuncha", "Muhammad Owais Latif", "Isaac Lee",
  "Jayden Lin", "Jewel Cate Llena-Barlis", "Rohan Madhav", "Abdullah Mahtab",
  "Maimoona", "Kimberly Mak", "Hridika Makkar", "Ariana Demi Mancao",
  "Zainab Manzar", "Imanam Maqwazima", "Marsel", "Hamna Maryam",
  "Cornelius Masih", "Aryan Mathur", "Merab", "Dinmukhammed Minetay",
  "Sankalp Mishra", "Hagar Hossam Mohammed", "Zainab Mudassar", "Abdul Mughees",
  "Aizara Mukhtar", "Jannat Muneeb", "Hajrah Ghayas Munir", "Djoni Muresan",
  "Javeria Mustafa", "Zeeha Nadeem", "Laiba Nadeem", "Natalia Naeem",
  "Harivighnesh Nagaraj", "Saad Nizami", "Hadia Noor", "Aruzhan Nurakhmetova",
  "Amir Ovezov", "Shray Paliwal", "Vedant Palsaniya", "Henil Parmar",
  "Sarayu Parvathala", "Naysha Patel", "Abhi Pathaneni", "Udita Phookan",
  "Vivan Poddar", "Ethan Poh", "Ponmanikandan Ponraj", "Arjun Popuri",
  "Sanjana Prabakar", "Abhinav Premkumar", "Latisha Saviola Putri", "Varun Puttagunta",
  "Keerthana Raghuraman", "Muhammad Ahsan Rasheed", "Kulalyev Ratbek", "M. Hassan Raza",
  "Sammiya Raza", "Isha Razil", "Mohammad Rehan", "Davi Tavares dos Reis",
  "Fazza Rizwan", "Sowrov Chandra Roy", "Muhammad Saad", "Kashan Sabir",
  "Mahnoor Saeed", "Ali Saeed", "Ahmed Saeed", "Fatima Saleem",
  "Rabia Saleem", "Abdul Sami", "Akshay Sandhyala", "Pritha Sankar",
  "Farhana Khan Sara", "Pavithraa Saravanan", "Khadeeja Sarfraz", "Sahil Sarfraz",
  "Dameli Sarsembayeva", "Tasbiha Sarwar", "Shreeka Satish", "Eleanor Sehn",
  "Aarav Sekhri", "Tirth Shah", "Sabiha Sharif", "Vivaan Sharma",
  "Himakshi Sharma", "Priyank Sharma-Tiwari", "Saood Faisal Sheikh", "Muhammad Ali Sher",
  "Sarah Shin", "Soham Dhar Shomya", "Muhammad Ibrahim Siddique", "Shaik Shahir Siddiqui",
  "Siraaj Singh", "Bhumija Singh", "Harsehaj Singh", "Dilda Sozakbay",
  "Harshita Srihari", "Adhrit Srinivasan", "Amogh Srivastava", "Andri Srivastava",
  "Eshal Sultan", "Zaria Tahir", "Saim Abdullah Tahir", "Muhammad Talha",
  "Suhaan Tammana", "Habiba Tanveer", "Muhammad Kashan Tariq", "Eiman Tariq",
  "Hania Naseem Tariq", "Pakiza Tariq", "Avani Thakur", "Vedhsai Thiriveedi",
  "Nurmukhammed Tolegenov", "Zarif Ula", "Dawood Usman", "Muhammad Usman",
  "Sanskruti Vannere", "Varshith Vijjapu", "Samaher Waheed", "Wajeeh-Ul-Rehman",
  "Amelia Wang", "Aayma Waseem", "Khizzar Waseem", "Ahmed Wez",
  "Steven Xia", "Sahithi Yalamanchli", "Danyan Yang", "Rosyima Yaqub",
  "Auel Yerzhan", "Akbota Yessimbay", "Iris Yu", "Maryam Zaheer",
  "Taha Ahmad Zahid", "Syeda Binte Zahra", "Syeda Nayyab Zahra", "Mariam Zahra",
  "Dua Zainab", "Javeria Zaryab", "Hassaan Zeeshan", "Sanzhar Zhaisanbayev",
  "Nurmukhammad Zhambululy", "Jessie Zhang", "Ahmed Zia", "Zohaadnan",
  "Jerry Zong", "Aiaulym Zumabek", "Mehmet Efe Cetinkaya",
];

function DistinguishedScholar2026() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredNames = scholars.filter(name =>
    name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Header Section */}
      <div style={{ marginBottom: '40px' }}>
        <span style={{
          display: 'inline-block',
          padding: '6px 14px',
          borderRadius: '6px',
          backgroundColor: 'rgba(0, 77, 153, 0.08)',
          color: '#004d99',
          fontSize: '0.85rem',
          fontWeight: '600',
          marginBottom: '16px'
        }}>
          March 2026
        </span>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '16px'
        }}>
          2026 Distinguished Scholars
        </h2>
        <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7' }}>
          <strong>Congratulations to our Distinguished Scholars!</strong> These students represent the top 20% of all IRO participants.
        </p>
      </div>

      {/* Stats */}
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '40px',
        flexWrap: 'wrap'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            {scholars.length}
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Distinguished Scholars</p>
        </div>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            Top 20%
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Of All Participants</p>
        </div>
      </div>

      {/* Search */}
      <div style={{ marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Search for a name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            maxWidth: '400px',
            padding: '14px 20px',
            fontSize: '1rem',
            border: '1px solid #e8eef3',
            borderRadius: '10px',
            outline: 'none',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => e.target.style.borderColor = '#004d99'}
          onBlur={(e) => e.target.style.borderColor = '#e8eef3'}
        />
      </div>

      {/* Names Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: '12px'
      }}>
        {filteredNames.map((name, index) => (
          <div key={index} style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '14px 18px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
            border: '1px solid #e8eef3',
            fontSize: '0.95rem',
            color: '#1a1a2e',
            fontWeight: '500'
          }}>
            {name}
          </div>
        ))}
      </div>

      {filteredNames.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginTop: '40px' }}>
          No results found for "{searchTerm}"
        </p>
      )}
    </div>
  );
}

export default DistinguishedScholar2026;
